import { Link } from "react-router-dom";

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="brand-logo" className="group inline-flex items-baseline gap-1.5 select-none">
    <span className={`font-display text-2xl font-extrabold tracking-tight ${light ? "text-[#FAF7F2]" : "text-[#1E1A17]"}`}>
      LATINA
    </span>
    <span className={`text-[11px] font-bold tracking-[0.18em] uppercase ${light ? "text-[#FAF7F2]/80" : "text-[#6E655F]"}`}>
      digital
    </span>
    <span className="rounded-md bg-[#E05A47] px-1.5 py-0.5 text-[11px] font-bold text-white transition-transform duration-300 group-hover:-rotate-6">
      IA
    </span>
  </Link>
);
